/**
 * Machine ids for `/api/observer/user-threads` 400 responses (`body.code`).
 * Must match `OBSERVER_QUERY_ERROR_CODES` in server `observerService.js`.
 */

export const OBSERVER_QUERY_ERROR_CODES = {
  INVALID_THREAD_DATE: 'INVALID_THREAD_DATE',
  INVALID_THREAD_DATE_RANGE: 'INVALID_THREAD_DATE_RANGE',
} as const;

export type ObserverQueryErrorCode =
  (typeof OBSERVER_QUERY_ERROR_CODES)[keyof typeof OBSERVER_QUERY_ERROR_CODES];

export function readObserverApiErrorCode(err: unknown): string | undefined {
  const c = (err as { code?: unknown })?.code;
  return typeof c === 'string' ? c : undefined;
}
